// User Side Bar
// Used in Favourites, Address, Profile

import Link from "next/link";
import { AiOutlineUser, AiFillHeart } from "react-icons/ai";
import { MdOutlineLogout } from "react-icons/md";
import { BsReceiptCutoff } from "react-icons/bs";
import { FaRegAddressCard } from "react-icons/fa";
import { useRouter } from "next/router";
import { signOut, useSession } from "next-auth/react";
import Cookies from "js-cookie";
import browserStorage from "store";
import { useTranslation } from "next-i18next";
import { event_user_logout } from "@/utils/gtm";

function Aside() {
  const { t } = useTranslation("common");
  const { data: session } = useSession();

  const { pathname } = useRouter();
  const router = useRouter();

  return (
    <aside className="border rounded-md max-[991px]:border-none h-fit">
      <ul className="max-[991px]:flex max-[991px]:items-center max-[991px]:gap-4 max-[991px]:overflow-auto">
        <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            pathname === "/user/profile" && "text-red bg-neutral-200"
          } max-[991px]:whitespace-nowrap max-[991px]:text-sm`}
        >
          <Link href="/user/profile" className="flex items-center">
            <AiOutlineUser size="19px" />
            <span className="mx-2">{t("account")}</span>
          </Link>
        </li>
        <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            (pathname === "/user/orders" ||
              pathname === "/user/orders/details") &&
            "text-red bg-neutral-200"
          } max-[991px]:whitespace-nowrap max-[991px]:text-sm`}
        >
          <Link href="/user/orders" className="flex items-center">
            <BsReceiptCutoff size="19px" />
            <span className="mx-2">{t("Orders")}</span>
          </Link>
        </li>
        {/* <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            pathname === "" && "text-red bg-neutral-200"
          }`}
        >
          <Link href="" className="flex items-center">
            <MdKeyboardReturn
              size="19px"
              className={lang === "en" ? "rotate-0" : "rotate-180"}
            />
            <span className="mx-2">{t("Returns")}</span>
          </Link>
        </li> */}
        <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            pathname === "/user/favourites" && "text-red bg-neutral-200"
          } max-[991px]:whitespace-nowrap max-[991px]:text-sm`}
        >
          <Link href="/user/favourites" className="flex items-center">
            <AiFillHeart size="19px" />
            <span className="mx-2">{t("MyFavourites")}</span>
          </Link>
        </li>
        <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            pathname === "/user/address" && "text-red bg-neutral-200"
          } max-[991px]:whitespace-nowrap max-[991px]:text-sm`}
        >
          <Link href="/user/address" className="flex items-center">
            <FaRegAddressCard size="19px" />
            <span className="mx-2">{t("MyAddresses")}</span>
          </Link>
        </li>
        {/* <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            pathname === "/user/credit" && "text-red bg-neutral-200"
          }`}
        >
          <Link href="/user/credit" className="flex items-center">
            <AiOutlineCreditCard size="19px" />
            <span className="mx-2">{t("MyCredit")}</span>
          </Link>
        </li>*/}
        <li
          className={`py-3 px-2 hover:bg-neutral-200 hover:text-red ${
            pathname === "" && "text-red bg-neutral-200"
          } max-[991px]:whitespace-nowrap max-[991px]:text-sm`}
        >
          <button
            className="flex items-center"
            onClick={() => {
              event_user_logout(
                session?.user?.firstname,
                session?.user?.lastname,
                session?.user?.email,
                session?.user?.id
              );
              signOut({ redirect: false });
              fetch("/api/auth/logout", { method: "POST" }).catch(() => {});
              Cookies.remove("region_id");
              browserStorage.remove("cart");
              browserStorage.remove("checkout");
              router.push("/");
            }}
          >
            <MdOutlineLogout className="rotate-180" size="19px" />
            <span className="mx-2">{t("LogOut")}</span>
          </button>
        </li>
      </ul>
    </aside>
  );
}

export default Aside;
